<template>
    <nav class="navbar navbar-expand-lg">
        <div class="container">
            <router-link class="navbar-brand" to="/admin/artists"><img src="@/assets/img/logo_black.svg" width="38"
                                                              style="margin-right: 20px;"></router-link>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText"
                    aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                <img src="@/assets/img/menu-bar.png"/>
            </button>
            <div class="collapse navbar-collapse" id="navbarText">
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <router-link class="nav-link" to="/admin/artists">Artists</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/admin/people">People</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/admin/events">Events</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/admin/press">Press</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/admin/campaigns">Campaigns</router-link>
                    </li>
                    <!--<li class="nav-item">-->
                        <!--<router-link class="nav-link" to="/admin/6ftapartList">6ftapart</router-link>-->
                    <!--</li>-->
                    <!--<li class="nav-item dropdown a-drop">-->
                        <!--<a href="javascript:void(0)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Campaigns <img src="@/assets/img/down.svg"/></a>-->
                        <!--<div class="dropdown-menu dropdown-menu-right pb-0" aria-labelledby="dropdownMenuButton">-->
                            <!--<router-link class="nav-link" to="/admin/6ftapart">6ftapart</router-link>-->
                        <!--</div>-->
                    <!--</li>-->
                </ul>
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <router-link class="nav-link" to="/">Home</router-link>
                    </li>
                    <li class="nav-item" v-if="!logedIn">
                        <router-link class="nav-link" to="/admin/login">Log In</router-link>
                    </li>
                    <li class="nav-item" v-if="logedIn">
                        <router-link class="nav-link" to="/admin/login">Log Out</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>

</template>

<style>
    .admin-page .contact-setion {
        padding-top: 170px;
    }
</style>

<script>
    import $ from "jquery"
    import router from '../../router'
    export default {
        name: 'AdminHeader',
        mounted() {
            $('#app').hide()
            $('#app').fadeIn()
            var lastScrollTop = 0
            $(window).scroll(function (event) {
                var st = $(this).scrollTop()
                if(st > 50){
                    if (st > lastScrollTop) {
                        // downscroll code
                        $('nav.navbar').css('top', -80)
                    } else {
                        // upscroll code
                        $('nav.navbar').css('top', 0)
                    }
                    lastScrollTop = st
                } else {
                    $('nav.navbar').css('top', 0)
                }
            })
            if(this.$route.name == 'AdminLogin'){
                localStorage.removeItem('cbs_admin_usertoken')
            } else {
                var userData = localStorage.getItem('cbs_admin_usertoken')
                if(userData){
                    this.logedIn = true
                } else {
                    router.push({ path: '/admin/login'})
                }
            }
        },

        data() {
            return {
                msg: 'Welcome to Your Vue.js App',
                logedIn: false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/Header.vue